define('components/photoset/helpers', [], function () {
    return {
        toStyleValue: function (complexNumber) {
            return 'calc(' + complexNumber.rel + '% + ' + complexNumber.abs + 'px)';
        }
    };
});